// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-feature-layer-feature-editor-modal.ant-modal {
  width: 60%;
  min-width: 40em;
  max-width: 80em;
  height: 80%;
  min-height: 40em;
}
.ngw-feature-layer-feature-editor-modal.ant-modal .ant-modal-content {
  height: 100%;
}
.ngw-feature-layer-feature-editor-modal.ant-modal .ant-modal-content > .ant-modal-body {
  height: 100%;
}
.ngw-feature-layer-feature-editor-modal.ant-modal > div + div {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/feature_layer/nodepkg/feature-editor-modal/FeatureEditorModal.less"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,eAAA;EACA,eAAA;EAEA,WAAA;EACA,gBAAA;AAAJ;AANA;EASQ,YAAA;AAAR;AATA;EAWY,YAAA;AACZ;AAZA;EAgBQ,YAAA;AADR","sourcesContent":[".ngw-feature-layer-feature-editor-modal.ant-modal {\n    width: 60%;\n    min-width: 40em;\n    max-width: 80em;\n\n    height: 80%;\n    min-height: 40em;\n\n    .ant-modal-content {\n        height: 100%;\n        > .ant-modal-body {\n            height: 100%;\n        }\n    }\n\n    > div + div {\n        height: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
